import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import NewsCard from "@/components/feature/NewsCard";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import { allNews, searchNews } from "@/lib/content";

const PAGE_SIZE = 5;

export default function NewsPage() {
  useDocumentMeta({
    title: "影视资讯 - 最新影视动态与影评推荐 - 国语对白做受69",
    description:
      "国语对白做受69影视资讯频道，汇聚最新行业动态、剧集资讯、幕后揭秘与影评推荐，帮助你及时了解影视圈的新鲜事。",
    keywords: "影视资讯,影视新闻,剧集资讯,影评推荐,国语对白做受69",
  });

  const [keyword, setKeyword] = useState("");
  const [page, setPage] = useState(1);

  const filtered = useMemo(() => searchNews(keyword), [keyword]);

  useEffect(() => {
    setPage(1);
  }, [keyword]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const paged = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <Layout>
      <section className="w-full bg-primary-950 text-background-50">
        <div className="w-full max-w-[1400px] mx-auto px-4 md:px-8 py-8 md:py-10">
          <nav className="text-xs md:text-sm text-background-400 mb-4 flex items-center gap-1.5">
            <Link to="/" className="hover:text-accent-400 transition-colors cursor-pointer">
              首页
            </Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-accent-400">影视资讯</span>
          </nav>
          <h1 className="text-2xl md:text-4xl font-bold font-heading">影视资讯</h1>
          <p className="mt-2 text-sm md:text-base text-background-300 max-w-2xl">
            行业动态、剧集资讯、幕后揭秘与影评推荐，第一时间了解影视圈的新鲜事。
          </p>
        </div>
      </section>

      <div className="w-full max-w-[1000px] mx-auto px-4 md:px-8 py-8 md:py-12">
        <form
          onSubmit={(e) => e.preventDefault()}
          className="flex items-center gap-2 mb-6"
        >
          <div className="relative flex-1">
            <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视资讯关键词"
              className="w-full h-11 pl-10 pr-4 rounded-md bg-background-50 border border-background-300 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-accent-500 transition-colors"
            />
          </div>
          {keyword && (
            <button
              type="button"
              onClick={() => setKeyword("")}
              className="h-11 px-4 rounded-md border border-background-300 text-sm text-foreground-600 hover:border-accent-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              清空
            </button>
          )}
        </form>

        {paged.length > 0 ? (
          <>
            <div className="space-y-3">
              {paged.map((article) => (
                <NewsCard key={article.id} article={article} />
              ))}
            </div>

            {totalPages > 1 && (
              <div className="mt-10 flex items-center justify-center gap-2">
                <button
                  type="button"
                  disabled={page === 1}
                  onClick={() => setPage((p) => Math.max(1, p - 1))}
                  className="w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-600 hover:border-primary-400 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-left-s-line"></i>
                </button>
                {Array.from({ length: totalPages }).map((_, i) => (
                  <button
                    key={i}
                    type="button"
                    onClick={() => setPage(i + 1)}
                    className={`w-9 h-9 rounded-md text-sm transition-colors cursor-pointer ${
                      page === i + 1
                        ? "bg-primary-600 text-background-50 font-medium"
                        : "border border-background-300 text-foreground-600 hover:border-primary-400"
                    }`}
                  >
                    {i + 1}
                  </button>
                ))}
                <button
                  type="button"
                  disabled={page === totalPages}
                  onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                  className="w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-600 hover:border-primary-400 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-s-line"></i>
                </button>
              </div>
            )}
          </>
        ) : (
          <div className="py-20 text-center bg-background-100 rounded-lg border border-background-200">
            <span className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-200 text-foreground-400">
              <i className="ri-newspaper-line text-3xl"></i>
            </span>
            <h3 className="mt-4 text-lg font-semibold text-foreground-800">未找到相关影视资讯</h3>
            <p className="mt-1.5 text-sm text-foreground-500">试试换个关键词，或清空搜索浏览全部资讯</p>
            <button
              type="button"
              onClick={() => setKeyword("")}
              className="mt-5 inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-accent-500 text-primary-950 text-sm font-medium hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-refresh-line"></i>
              清空搜索
            </button>
          </div>
        )}

        <p className="mt-8 text-center text-xs text-foreground-400">
          共 {allNews.length} 条资讯 · 搜索与分页为演示用途，数据非实时
        </p>
      </div>
    </Layout>
  );
}